/*
 * Bee Raw — diskret scroll-reveal (fade + let løft).
 * Idempotent: kan inkluderes af flere br-sektioner uden at initialisere flere gange.
 * Respekterer prefers-reduced-motion.
 */
(function () {
  if (window.__brRevealInit) return;
  window.__brRevealInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    var nodes = document.querySelectorAll('[data-br-reveal]:not(.br-is-revealed)');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('br-is-revealed');
  }

  function init() {
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('br-is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    function observe() {
      document.querySelectorAll('[data-br-reveal]:not(.br-is-revealed)').forEach(function (el) {
        observer.observe(el);
      });
    }

    observe();
    // Theme editor: re-scan når sektioner gen-renderes.
    document.addEventListener('shopify:section:load', observe);
    window.__brRevealObserve = observe;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
